if (!customElements.get('pack-size-selector')) {
  customElements.define(
    'pack-size-selector',
    class PackSizeSelector extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.productForm = this.productInfo?.querySelector('product-form');
        this.form = this.productForm?.querySelector('form[data-type="add-to-cart-form"]');
        this.inputs = Array.from(this.querySelectorAll('input[type="radio"]'));

        if (!this.form || this.inputs.length === 0) return;

        this.inputs.forEach((input) => {
          input.addEventListener('change', () => this.selectPack(input));
        });

        const selectedInput = this.inputs.find((input) => input.checked) || this.inputs.find((input) => !input.disabled);
        if (selectedInput) {
          selectedInput.checked = true;
          this.selectPack(selectedInput, false);
        }
      }

      selectPack(input, updateUrl = true) {
        const variantInput = this.form.querySelector('input[name="id"]');
        const submitButton = this.productForm?.querySelector('[type="submit"][name="add"]');
        const submitLabel = submitButton?.querySelector('[data-product-submit-label]');
        const isAvailable = input.dataset.available === 'true';

        if (variantInput) {
          variantInput.value = input.value;
          variantInput.disabled = false;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (submitButton) {
          submitButton.toggleAttribute('disabled', !isAvailable);
          if (isAvailable) {
            submitButton.removeAttribute('aria-disabled');
          } else {
            submitButton.setAttribute('aria-disabled', 'true');
          }
        }

        if (submitLabel) {
          submitLabel.textContent = isAvailable ? input.dataset.buttonLabel : input.dataset.soldOutLabel;
        }

        if (updateUrl && this.productInfo?.dataset.updateUrl === 'true' && input.dataset.variantUrl) {
          window.history.replaceState({}, '', input.dataset.variantUrl);
        }
      }
    }
  );
}
